<template>
  <b-modal
    :visible="showModal"
    @hidden="handleClose"
    title="Histórico do Estabelecimento"
    size="xl"
    hide-footer
    centered
  >
    <div v-if="isLoading" class="loading-container">
      <b-spinner variant="primary"></b-spinner>
    </div>
    <div v-else>
      <h3 class="titulo">
        Histórico do Estabelecimento: {{ establishmentId }}
      </h3>
      <div class="row">
        <div
          v-for="(item, index) in rentData"
          :key="index"
          class="col-12 rent-item-box"
        >
          <div class="info-columns">
            <div class="info-column">
              <div class="info-row">
                <strong>Nome: </strong><span>{{ item.name }}</span>
              </div>
              <div class="info-row">
                <strong>EC: </strong><span>{{ item.establishmentId }}</span>
              </div>
              <div class="info-row">
                <strong>Pago: </strong
                ><span>{{ booleanToString(item.paid) }}</span>
              </div>
              <div class="info-row">
                <strong>Tipo: </strong><span>{{ item.type }}</span>
              </div>
            </div>

            <div class="info-column">
              <div class="info-row">
                <strong>Data: </strong><span>{{ formatDate(item.date) }}</span>
              </div>
              <div class="info-row">
                <strong>ID do balanço: </strong
                ><span>{{ item.balanceId }}</span>
              </div>
              <div class="info-row">
                <strong>Descrição: </strong><span>{{ item.description }}</span>
              </div>
              <div class="info-row">
                <strong>Disponível: </strong
                ><span>{{ formatCurrency(item.available) }}</span>
              </div>
            </div>

            <div class="info-column">
              <div class="info-row">
                <strong>Aguardando valores: </strong
                ><span>{{ formatCurrency(item.waitingFunds) }}</span>
              </div>
              <div class="info-row">
                <strong>Taxa: </strong
                ><span>{{ formatCurrency(item.fee) }}</span>
              </div>
              <div class="info-row">
                <strong>Valor: </strong
                ><span>{{ formatCurrency(item.amount) }}</span>
              </div>
              <div class="info-row">
                <strong>Valor Líquido: </strong
                ><span>{{ formatCurrency(item.netAmount) }}</span>
              </div>
            </div>

            <div class="info-column">
              <div class="info-row">
                <strong>Saldo Anterior: </strong
                ><span>{{ formatCurrency(item.balanceOldAmount) }}</span>
              </div>
              <div class="info-row">
                <strong>Saldo Atual: </strong
                ><span>{{ formatCurrency(item.balanceAmount) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BSpinner, BModal } from "bootstrap-vue";
import axios from "axios";
export default {
  props: {
    establishmentId: {
      type: Number,
      required: false,
    },
    formattedDate: {
      type: String,
      required: false,
    },
    showModal: {
      type: Boolean,
      required: false,
    },

  },
  components: {
    BSpinner,
    BModal,
  },
  data() {
    return {
      isLoading: false,
      rentData: [],
    };
  },
  watch: {
    showModal(newValue) {
      if (newValue) {
        this.fetchRentData();
      }
    },
     establishmentId(newEstablishmentId) {
    if (newEstablishmentId) {
      this.fetchRentData();
    }},
  },
  methods: {
    async fetchRentData() {
      try {
        if (!this.formattedDate || !this.establishmentId) return;

        this.isLoading = true;
        const BASE_URL = process.env.VUE_APP_BASE_URL_THOTH;
        const API_KEY = process.env.VUE_APP_API_KEY_THOTH;

        const response = await axios.get(`${BASE_URL}rent-validator`, {
          params: {
            date: this.formattedDate,
            ec: this.establishmentId,
          },
          headers: { "Api-Key": API_KEY },
        });
        const rentPaidEc = response.data.rent.rentPaid;
        const rentChargedEc = response.data.rent.rentCharged;
        this.rentData = response.data.rent.data[this.establishmentId];
        this.$emit("updateRentValues", { rentPaidEc, rentChargedEc });
        this.$emit("changeLoading")
      } catch (error) {
        console.error("Erro na requisição:", error);
      } finally {
        this.isLoading = false;
      }
    },
    handleClose() {
      this.$emit("update:showModal", false);
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    booleanToString(value) {
      return value ? "SIM" : "NÃO";
    },
  },
};
</script>

<style>
.rent-item-box {
  border: 1px solid black;
  padding: 10px;
  border-radius: 5px;
  background-color: #f2f3f7;
  display: flex;
  flex-direction: column;
  width: 90%;
  margin-bottom: 15px;
}
.row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
  align-items: center;
}

.info-columns {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.info-column {
  flex: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
}

.info-row {
  width: 100%;
  display: flex;
  margin: 5px;
}
span {
  padding-left: 10px;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.titulo {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>